// @flow

import styled, { css } from "styled-components";
import buildFDRColor from "@fdr/static-ui/ColorPalette";

const FooterNav = styled.nav`
  display: flex;
  ${(props) =>
    props.layout === "horizontal"
      ? css`
          min-height: 48px;
          background-color: ${buildFDRColor("white", "100")};
          box-shadow: 0 -1px 0 0 ${buildFDRColor("grey", "200")};
          justify-content: space-between;

          & > a,
          button {
            flex: 0 0 20%;
          }
        `
      : css`
          flex-direction: column;
          width: 56px;
          align-items: center;
          justify-content: center;

          & > a,
          button {
            margin: 8px 0;
            height: 48px;
          }
        `};
`;

export default FooterNav;
